export const dataToRow = (item) => ({
  id: item.methodCode,
  methodCode: item.methodCode,
  tapOnFee: item.tapOnFee || 0,
})
